import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import GuideProfileHeader from "pagesV2/pro/GuideProfile/GuideHeader"
import withDefaultErrorBoundary from "modules/errors/HOCs/withDefaultErrorBoundary"
import DefaultErrorBoundary from "modules/errors/DefaultErrorBoundary"
import { useSelector } from "react-redux"
import { modelSelector } from "store/selectors"
import GuideNavigationTabs from "pagesV2/pro/GuideProfile/GuideNavigationTabs"
import Header from "components/layout/Header"
import IconWithBg from "ui/IconWithBg"
import { LeftOutlined } from "@ant-design/icons"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Title } from "ui/Typography"

const ProGuideProfileLayout = () => {
  const navigate = useNavigate()
  const guide = useSelector(modelSelector("guide"))
  const { t } = useTranslation()

  const handleBack = () => {
    navigate(-1)
  }

  return (
    <main>
      <Header />
      <Flex gap={10} className="py-xl  container">
        <IconWithBg onClick={handleBack} icon={<LeftOutlined />} />
        <Title level={4}>{t("guide.navigation.guide_profile")}</Title>
      </Flex>

      <div className="  container">
        <GuideProfileHeader guide={guide} />
        <GuideNavigationTabs slug={guide?.slug} />
      </div>
      <div>
        <DefaultErrorBoundary>
          <Outlet />
        </DefaultErrorBoundary>
      </div>
    </main>
  )
}

export default withDefaultErrorBoundary(ProGuideProfileLayout)
